import appContent from '@/services/content/appContent.typed';

import AutoDeliveryDcxInactiveBannerWidget from './components/AutoDeliveryDcxInactiveBannerWidget';

interface AutoDeliveryDcxStatusFailedProps {
    className?: string;
}

const AutoDeliveryDcxStatusFailed = ({className}: AutoDeliveryDcxStatusFailedProps) => {
    const {banner} = appContent.getAutoDeliveryContent()?.dashboardContent?.failedDeliveryOnboardingDashboard || {};

    return <AutoDeliveryDcxInactiveBannerWidget className={className} banner={banner} />;
};

export default AutoDeliveryDcxStatusFailed;
